<template>
    <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" fullscreen
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obForm.titulo"></span>
                <v-spacer></v-spacer>
                 <v-icon dark @click="closeModal">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Contratante" color="textbox"
                                    v-model="obModal.contratante" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Póliza" color="textbox"
                                    v-model="obModal.poliza" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="N° Certificado" color="textbox"
                                    v-model="obModal.idCertificado" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Fecha Emisión" color="textbox"
                                    v-model="obModal.fechaEmision" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Fecha Desde" color="textbox"
                                    v-model="obModal.fechaDesde" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Fecha Hasta" color="textbox"
                                    v-model="obModal.fechaHasta" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field dense label="Broker" color="textbox"
                                    v-model="obModal.broker" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="N° Documento" color="textbox"
                                    v-model="obModal.nroDocumento" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field dense label="Cliente" color="textbox"
                                    v-model="obModal.cliente" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field dense label="Dirección" color="textbox"
                                    v-model="obModal.direccion" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Teléfono" color="textbox"
                                    v-model="obModal.telefonoPbx" outlined readonly/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Correo" color="textbox"
                                    v-model="obModal.email" outlined readonly/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-list two-line subheader>
                                    <v-subheader inset>Documentos</v-subheader>

                                    <v-list-item
                                        v-for="item in listFile"
                                        :key="item.title"
                                        @click="verFile(item)"
                                    >
                                        <v-list-item-avatar>
                                        <v-icon
                                            :class="[item.iconClass]"
                                            v-text="item.icon"
                                        ></v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                        <v-list-item-title v-text="item.title"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon color="primary">visibility</v-icon>
                                        </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>

                        <v-row dense >
                            <v-col cols="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" class="text-right">
                                <v-btn outlined rounded class="mr-1" @click="closeModal">Cancelar</v-btn>
                            </v-col>
                        </v-row>  
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalConsultaPolizaClienteComponent',
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        inject:['closeModal'],
        props: {
            open: {
                type: Boolean,
                default: false
            },
            obForm: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            },
        }),
        computed:{
            obModal(){
                return _.get(this.obForm,'data',{});
            },
            listFile(){
                var l = _.get(this.obForm,'listDocumentos',[]);

                return _.map(l,(v)=>{
                                    return {
                                        title: _.startCase(_.split(v.file,'.pdf')[0]),
                                        iconClass: 'blue white--text',
                                        icon: 'assignment',
                                        path: v.path
                                    }
                                });
            }
        },
        methods:{
            verFile(v){
                axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': v.path })
                             .then((r) => {
                                 if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                 if(_.size(_.get(r,['data','data'],[])) == 0) throw 'Error al leer el archivo PDF.';
                                    this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                    this.objPdf.titulo = v.title;
                                    this.objPdf.mostrar = true;
                             })
                             .catch((e)=>{
                                mensajesAlerta(e,'E');
                             })
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>